module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_null@3x.2491afbe.png";